import h from "trader-hyperscript";
import { Form } from "trader.ts/ui.forms";
import { studentid } from "../../../sql/classy/types";
import { typeaheadField } from "../../client/typeaheadfield";
import { ddMMyyyy, renderFirstNameLastName } from "../../render";
import * as routes from "../../routes";
import {
  renderReportResult,
  runQueryOnFormChange,
} from "../finance_invoices/client";
import { isNumber } from "../../lib/istype";
import * as joda from "@js-joda/core";
import { renderBehindToggle } from "../../client/renderbehindtoggle";
import { Source } from "trader.ts/types/source";

export function render(opts: {
  allStudents: { id: studentid; firstname: string; lastname: string }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("student", [], async () =>
      typeaheadField(
        async ({ searchstring }) =>
          opts.allStudents.filter((s) =>
            renderFirstNameLastName(s)
              .toLowerCase()
              .includes(searchstring.toLowerCase()),
          ),
        (s) => (s === null ? "" : renderFirstNameLastName(s)),
        {
          maxCandidatesToShow: 5,
          initial: null,
          label: "Student",
        },
      ),
    )
    .build();

  const res = runQueryOnFormChange(
    form.s,
    routes.searchAuditLogOnStudentSpec,
    (t) => t,
  );

  return (
    <main style="max-width: unset;">
      {form.render()}
      {renderReportResult(res, (rows) => {
        return (
          <table>
            {rows.map((row) => {
              const showingStudentsS = new Source(false);
              const showingExtraS = new Source(false);
              return (
                <tr>
                  <td>{row.stamp.atZone(joda.ZoneId.UTC).format(ddMMyyyy)}</td>
                  <td>
                    <div>
                      <b>{row.description}</b>
                    </div>
                    <div>{row.useremail}</div>
                  </td>
                  <td>
                    {renderBehindToggle(
                      showingStudentsS,
                      "Studenten & Inschrijvingen",
                      <div>
                        <div>
                          {"Studenten" + ": "}
                          {row.studentids.map((studentid) => (
                            <a
                              href={routes.studentOverviewRoute.link({
                                studentid,
                              })}
                            >
                              {studentid.toString()}
                            </a>
                          ))}
                        </div>
                        <div>
                          {"Inschrijvingen" + ": "}
                          {(row.lessongroupids || []).map((lg) =>
                            isNumber(lg) ? (
                              <span>{lg.toString()}</span>
                            ) : (
                              <a
                                href={routes.lessongroup_generalRoute.link({
                                  lessongroupid: lg.lessongroupid,
                                })}
                              >
                                {lg.enrollmentid}
                              </a>
                            ),
                          )}
                        </div>
                      </div>,
                    )}
                  </td>
                  <td>
                    {renderBehindToggle(
                      showingExtraS,
                      "Extra",
                      <pre>
                        {JSON.stringify(
                          JSON.parse(row.extrainfo || ""),
                          null,
                          2,
                        )}
                      </pre>,
                    )}
                  </td>
                </tr>
              );
            })}
          </table>
        );
      })}
    </main>
  );
}
